import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form";

import Button from "../../modules/Button";
import FieldSet from "../../modules/FieldSet";
import InputGroup from "../../modules/InputGroup";
import Input from "../../modules/Input";
import SelectBox from "../../modules/SelectBox";
import TextArea from '../../modules/TextArea';
import FormButtonPanel from "../../modules/FormButtonPanel";

import * as serviceActions from '../../../actions/services';
import * as supportActions from '../../../actions/support';

import styles from './styles.scss';
import AlertBox from "../../modules/AlertBox";
import FormatAlertMessage from "../../modules/FormatAlertMessage";
import AlertMessage from "../../modules/AlertMessage";

const SupportForm = ({
                         pristine,
                         handleSubmit,
                         submitting,
                         change,
                         error,
                         initialValues: {
                             service_id,
                         },
                         services,
                         refreshServices,
                     }) => {
    useEffect(() => {
        refreshServices();
    }, []);

    if (!services) return null;

    useEffect(() => {
        if (services.length > 0 && service_id) {
            change('service_id', service_id);
        }
    }, [services, service_id]);

    return (
        <div>
            <AlertMessage>
                {error && (
                    <AlertBox theme="danger">
                        <FormatAlertMessage
                            genericMessage={'There was a problem submitting your support ticket.'}
                            error={error}
                        />
                    </AlertBox>
                )}
            </AlertMessage>
            <form onSubmit={handleSubmit}>
                <FieldSet legend="Support">
                    <InputGroup>
                        <Field name="service_id" component={SelectBox} type="integer" label="Service" required="true">
                            <option value={null}>Please select</option>
                            {services.map((service) => (
                                <option key={service.id} value={parseInt(service.id)}>{service.name}</option>
                            ))}
                        </Field>
                        <Field name="sender_email" component={Input} type="email" label="Sender Email" required="true" />
                        <Field name="sender_full_name" component={Input} type="string" label="Full Name" required="true" />
                        <Field name="subject" component={Input} type="string" label="Subject" required="true" autocomplete="off"/>
                        <Field name="body" component={TextArea} type="string" label="Body" required="true" />
                    </InputGroup>
                </FieldSet>

                <FormButtonPanel position="bottom">
                    <Button disabled={pristine || submitting} type="submit">Submit</Button>
                </FormButtonPanel>
            </form>
        </div>
    )
}

const MapStateToProps = (state) => {
    return {
        initialValues: state.support.form.initialValues,
        services: state.services.services,
    };
}

const MapDispatchToProps = (dispatch) => {
    return {
        refreshServices() {
            dispatch(serviceActions.refreshAllServices({orderBy: {
                column: 'name',
                direction: 'ASC',
            }}));
        },
        onSubmit(params) {
            return dispatch(supportActions.submit(params));
        },
    }
}

export default connect(MapStateToProps, MapDispatchToProps)(
    reduxForm({
        form: 'support',
        fields: [
            'service_id',
            'sender_email',
            'sender_full_name',
            'subject',
            'body',
        ],
    })(SupportForm));